import * as yup from 'yup'

export class CompanyInsuranceCompanyInformationDto {
  insuranceSuretyImageSealFileName?: string = undefined
  insuranceUnderwriterCompanyName?: string = undefined
  insuranceSuretyCode?: string = undefined
  insuranceSuretyImageSealFile?: File = undefined
  needsAddress?: boolean = false
  needsEmail?: boolean = false
  needsPhone?: boolean = false
}

export const companyInsuranceCompanyInformationValidationSchema = yup.object({
  insuranceUnderwriterCompanyName: yup
    .string()
    .max(200, 'Underwriter Company Name cannot be more than 200 characters.')
    .required('Underwriter Company Name is required.'),
  insuranceSuretyCode: yup
    .string()
    .max(200, 'Surety Code cannot be more than 200 characters.')
    .required('Surety Code is required.'),
  insuranceSuretyImageSealFile: yup
    .mixed()
    // @ts-ignore
    .test('Surety Image Seal is required.', (value: File) => !!value)
    .required('Surety Image Seal is required.')
})
